import { ShiftDto } from '../_models/shift.models';
import axios, { AxiosResponse } from 'axios';

const getAllShiftList = (): Promise<AxiosResponse<ShiftDto[]>> => {
    return axios.get('/api/v1/shifts');
}

export const shiftService = {
    getAllShiftList
}
